import cn from 'classnames'
import AlertBanner from 'ext-ui/components/AlertBanner/AlertBanner'
import { base_colorAlert } from 'ext-ui/style/colors'
import React, { ComponentProps, ReactElement, useMemo } from 'react'
import SvgFlagNew from 'src/components/Svgs/SvgFlagNew'
import { useTranslate } from 'src/localization/Trns'
import {
  TransactionDetailModel,
  transactionManagerReviewRejectionReasonToString,
} from 'src/models/transaction.models'
import { useQueryUser } from 'src/queries/users.queries'

type RejectionNoticeProps = {
  className?: string
  transaction: TransactionDetailModel
  variant?: 'short' | 'long'
} & ComponentProps<'div'>

function RejectionNotice(props: RejectionNoticeProps): ReactElement {
  const translate = useTranslate()
  const { className = '', transaction, variant = 'short', ...rest } = props

  const { data: manager } = useQueryUser({
    userId: transaction?.managerReviewId,
    enabled: variant === 'long',
  })

  const subcopy = useMemo(() => {
    switch (variant) {
      case 'long':
        if (transaction.managerRejectionNote) {
          return translate(
            '${manager} has rejected this transaction: "${rejectionNote}"',
            {
              manager: manager?.fullNameOrEmail || '',
              rejectionNote: transaction.managerRejectionNote || '',
            },
          )
        } else {
          return translate('${manager} has rejected this transaction.', {
            manager: manager?.fullNameOrEmail || '',
          })
        }
      case 'short':
      default:
        if (transaction.managerRejectionNote) {
          return translate('"${rejectionNote}"', {
            rejectionNote: transaction.managerRejectionNote,
          })
        }
    }
    return undefined
  }, [variant, transaction, translate, manager])

  return (
    <AlertBanner
      className={cn('RejectionNotice', className)}
      data-testid="rejection-notice"
      variant={'severe'}
      icon={<SvgFlagNew fill={base_colorAlert} />}
      title={translate('Action Required: ${rejectionReason}', {
        rejectionReason: translate(
          transactionManagerReviewRejectionReasonToString(
            transaction.managerRejectionReason,
          ),
        ),
      })}
      {...rest}
    >
      {subcopy}
    </AlertBanner>
  )
}

export default RejectionNotice
